import { api } from '../../plugins/api';

const getDefaultState = () => {
  return {
    formations: [],
  }
}

const state = getDefaultState()

const getters = {
  GET_ALL_FORMATIONS: (state) => { return state.formations },
  GET_FORMATIONS: (state) => { return state.formations.filter(f => !f.deleted || f.deleted != true) },
  GET_FORMATION: (state, index) => { return state.formations[index] },
}

const mutations = {
  SET_FORMATIONS (state, formations) {
    state.formations = formations
  },
  SET_FORMATION_ID (state, payload) {
    state.formations[payload.index].id = payload.id
  },
  ADD_FORMATION (state, formation) {
    state.formations.push(formation)
  },
  REMOVE_FORMATION (state, formation) {
    state.formations.splice(state.formations.indexOf(formation), 1);
    if (formation.id != null) {
      formation.deleted = true;
      state.formations.push(formation)
    }
  },
  UPDATE_FORMATION (state, formation) {
    state.formations[state.formations.indexOf(state.formations.find(a => a.id == formation.id))] = formation
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

const actions = {
  async getFormationInitialeByContactId({ commit }, pContactId) {
    let response = await api.get(`formationsinitiales/contacts/` + pContactId);
    commit("SET_FORMATIONS", response.data);
  },
  async updateFormationInitiale({ commit }, pFormationInitialeDTO){
    const response =  await api.put(`formationsinitiales`, pFormationInitialeDTO);
    commit("UPDATE_FORMATION", response.data);
  },
  async createFormationInitiale({state, commit}, payload){
    const response =  await api.post(`formationsinitiales`, payload.formation);
    if(response.data){
      let id = response.data;
      let index = payload.index;
      commit("SET_FORMATION_ID", {index, id});
    }
  },
  async deleteFormationInitiale({ state, commit }, id){
    const response =  await api.delete(`formationsinitiales/` + id);
    if(response.data == true){
      commit("REMOVE_FORMATION", state.formations.find(a => a.id == id))
    }
  },
  async getFormationInitialeByDemandeAdmissionId({ commit }, pDemandeAdmissionId){
    const response =  await api.get(`formationsinitiales/demandesadmissions/` + pDemandeAdmissionId)
    commit("SET_FORMATIONS", response.data);
  },
  resetModuleState ({ commit }) {
    commit('resetState')
  },
}

export default ({
    namespaced: true,
    state: state,
    mutations: mutations,
    getters: getters,
    actions: actions
})